import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
// import AuthService from './services/authService'
import Login from './views/Login.vue'
import PostLogout from './views/PostLogout.vue'
import AuthCallback from './views/AuthCallback.vue'
import StripeCallback from './views/StripeCallback.vue'
import ProfileStart from './views/ProfileStart.vue'
import Subscription from './views/Subscription.vue'
import Profile from './views/Profile.vue'

Vue.use(Router)

// const authService = new AuthService()
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/logout',
      name: 'post-logout',
      component: PostLogout,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/authcallback',
      name: 'auth-callback',
      component: AuthCallback,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/stripecallback',
      name: 'stripe-callback',
      component: StripeCallback,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/profilestart',
      name: 'profile-start',
      component: ProfileStart
    },
    {
      path: '/',
      name: 'subscription',
      component: Subscription
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log("TO", to)
  console.log("FROM", from)
  // console.log(`Changing routes to ${to.name}. Route is anonymous? ${to.meta.allowAnonymous} user is logged in? ${store.getters.isLoggedIn}`)
  if (to.meta.allowAnonymous || store.getters.isLoggedIn) {
    if (store.getters.isLoggedIn && store.state.loggedInUser == null && to.name != 'auth-callback')
    {
      next({ path: from.name == null ? '/authcallback' : from.fullPath})
    }
    else if (store.getters.isLoggedIn && store.state.loggedInUser.has_completed_setup == false && to.name != 'profile-start' && to.name != 'stripe-callback')
    {
      next({ path: '/profilestart'})
    }
    else {
      next()
    }
  }
  else {
    next({ path: '/login', query: { redirect: to.fullPath } })
  }
})

export default router